import React, { ReactElement } from 'react';
import { Route, Routes, useParams } from 'react-router';
import { bilModellPath } from '@universal/routing/bilModellPath';
import ElbilGuide from '../pages/ElbilGuide/ElbilGuide';
import BilModell from '../pages/BilModell/BilModell';
import { NotFound } from '../loadable-elements/NotFound';

const BilModellRoute = (): ReactElement => {
  const { carSlug } = useParams<{ carSlug?: string }>();
  if (!carSlug) {
    return <NotFound />;
  }
  return <BilModell key={carSlug} carSlug={carSlug} />;
};

export const BilGuideRouter = (): ReactElement => (
  <Routes>
    <Route index element={<ElbilGuide />} />
    <Route path="null" element={<NotFound />} />
    <Route path={bilModellPath} element={<BilModellRoute />} />
  </Routes>
);
